/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EnumItem5
 */
export interface EnumItem5 {
    /**
     * 编码
     * @type {number}
     * @memberof EnumItem5
     */
    code?: number;
    /**
     * 枚举标识名
     * @type {string}
     * @memberof EnumItem5
     */
    enumName?: string;
    /**
     * 名称（根据语言环境返回）
     * @type {string}
     * @memberof EnumItem5
     */
    name?: string;
}

/**
 * Check if a given object implements the EnumItem5 interface.
 */
export function instanceOfEnumItem5(value: object): value is EnumItem5 {
    return true;
}

export function EnumItem5FromJSON(json: any): EnumItem5 {
    return EnumItem5FromJSONTyped(json, false);
}

export function EnumItem5FromJSONTyped(json: any, ignoreDiscriminator: boolean): EnumItem5 {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'enumName': json['enumName'] == null ? undefined : json['enumName'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function EnumItem5ToJSON(json: any): EnumItem5 {
    return EnumItem5ToJSONTyped(json, false);
}

export function EnumItem5ToJSONTyped(value?: EnumItem5 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'enumName': value['enumName'],
        'name': value['name'],
    };
}

